import PlayButton from "components/PlayButton";
import PropTypes from "prop-types";
import React from "react";
import controlStyles from "Controls/Controls.css";
import VolumeControlContainer from "containers/VolumeControlContainer";
import FullscreenButton from "components/FullscreenButton";
import MobileChapterControlsSliderContainer from "containers/MobileChapterControlsSliderContainer";
import MobileChapterNumbersContainer from "containers/MobileChapterNumbersContainer";
import CSSTransitionGroup from "react-addons-css-transition-group";
import ChapterControlsInactiveSliderContainer from "containers/ChapterControlsInactiveSliderContainer";
import CaptionButtonContainer from "containers/controls/CaptionButtonContainer";
import styles from "./MobileChapterControls.css";
import { SettingsButton } from "../SettingsButton";
import { SeekBackButton } from "../SeekBackButton";
import { SeekForwardButton } from "../SeekForwardButton";
import { PlaybackProgressText } from "../PlaybackProgressText";

const MobileChapterControls = ({
  canControlVolume,
  chapterId,
  controlsMode,
  duration,
  onPlayButtonClick,
  playing,
  showChapterNavigationMarkers,
  showCoutdownTimerInControls,
  showSeekButtons,
  showSettingsMenu,
  time,
}) => (
  <div aria-label="chapter controls">
    <CSSTransitionGroup
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={1000}
      transitionName={{
        enter: controlStyles.transitionEnter,
        enterActive: controlStyles.transitionEnterActive,
        leave: controlStyles.transitionLeave,
        leaveActive: controlStyles.transitionLeaveActive,
      }}
    >
      {controlsMode === "full" && (
        <div
          className={`${controlStyles.controls} ${styles.controls}`}
          key="full"
        >
          <div className={styles.root}>
            <MobileChapterControlsSliderContainer chapterId={chapterId} />
            <div className={styles.buttons}>
              <PlayButton
                handlePlayButtonClick={onPlayButtonClick}
                playing={playing}
              />
              {showSeekButtons && (
                <>
                  <SeekBackButton chapterId={chapterId} />
                  <SeekForwardButton chapterId={chapterId} />
                </>
              )}
              {showCoutdownTimerInControls && (
                <PlaybackProgressText time={time} duration={duration} />
              )}
              <div className={styles.otherButtons}>
                <div className={styles.chapterNumbers}>
                  {showChapterNavigationMarkers && (
                    <MobileChapterNumbersContainer
                      chapterId={chapterId}
                      mobileSizing
                      showChapterNavigationMarkers={
                        showChapterNavigationMarkers
                      }
                    />
                  )}
                </div>

                {showSettingsMenu !== "hide" ? (
                  <SettingsButton visible={showSettingsMenu === "force"} />
                ) : (
                  <CaptionButtonContainer
                    border={false}
                    chapterId={chapterId}
                  />
                )}
                {canControlVolume && <VolumeControlContainer />}
                <FullscreenButton />
              </div>
            </div>
          </div>
        </div>
      )}
      {controlsMode === "compact" && (
        <div className={styles.root} key="compact">
          <ChapterControlsInactiveSliderContainer chapterId={chapterId} />
        </div>
      )}
    </CSSTransitionGroup>
  </div>
);

MobileChapterControls.propTypes = {
  canControlVolume: PropTypes.bool.isRequired,
  chapterId: PropTypes.number.isRequired,
  controlsMode: PropTypes.oneOf(["full", "compact"]),
  duration: PropTypes.number.isRequired,
  onPlayButtonClick: PropTypes.func.isRequired,
  playing: PropTypes.bool.isRequired,
  showChapterNavigationMarkers: PropTypes.bool.isRequired,
  showCoutdownTimerInControls: PropTypes.bool.isRequired,
  showSeekButtons: PropTypes.bool.isRequired,
  showSettingsMenu: PropTypes.oneOf(["auto", "force", "hide"]).isRequired,
  time: PropTypes.number.isRequired,
};

export default MobileChapterControls;
